<template>
  <div class="background" v-if="loadPage < 3">
    <Loader/>
  </div>
  <div class="background" v-else>
    <div class="header">
      <h1>EXAMEN DE CONDUITE</h1>
      <br>
      <button class="btn btn-danger" @click="this.$router.push({ name: 'eleve_conduite' });">RETOURNER AU PLANNING</button>
    </div>
    
    <template v-if="this.passage.length === 0 && this.exam.length === 0 || this.passage.length === 0 && this.exam.length !== 0 && this.exam[0].dateProb < Date() || this.passage.length !== 0 && this.passage[0].demande === '11/10/1111' && this.exam.length === 0">
      <div class="demandePassage">
        <p class="title">Vous souhaitez demander une place d'examen de conduite ?</p>
        <p class="subTitle">1. Avez-vous une préférence sur le lieu d'examen ?</p>
        <MultiSelect
          class="mutltiSelectLieux"
          v-model="lieu"
          :options="lieux"
          optionValue="id"
          optionLabel="nom"
          placeholder="Lieux d'examen"
          :disabled="desac"
        />
        <p class="subTitle">2. Avec quel moniteur aimeriez-vous passer votre examen ?</p>
        <select name="mono" id="mono" v-model="mono">
          <option value="">Choisir un moniteur</option>
          <template v-for="m in monos" :key="m.id">
            <option :value="m.id">{{ m.nom }}</option>
          </template>
        </select>
        <p class="subTitle">3. Avez-vous un impératif dont nous devons tenir compte ?</p>
        <textarea name="com" id="com" v-model="commentaire"></textarea>
        <p class="subTitle">4. Nous vous programmerons au préalable un examen blanc. L'examen blanc coûte {{this.infoEleve.prixEb}}€. Merci de prévoir une plage horaire de 3H pour la réalisation de la simulation d'examen</p>
        <p class="subTitle">5. Le prix de l'examen de conduite est de {{this.infoEleve.prixHeure}}€</p>

        <button class="btn btn-primary" @click="setDemande('null', 'null')" v-if="loadBtn === false">VALIDER ET DEMANDER MA PLACE D'EXAMEN</button>
        <button @click="setDemande('null', 'null')" class="btn btn-primary" disabled v-else><span><i class="fa fa-spinner fa-spin"></i>VALIDER ET DEMANDER MA PLACE D'EXAMEN</span></button>
      </div>

    </template>

    <template v-else-if="this.passage.length !== 0 && this.exam.length === 0 && this.examBlanc.length === 0">
      <div class="demandePassage">
        <p class="subTitle">1. Nous avons pris en compte votre demande. Un examen blanc vous sera proposé prochainement</p>
        <p class="subTitle">2. Souhaitez-vous modifier vos préférences concernant les lieux d'examen</p>
        <MultiSelect
          class="mutltiSelectLieux"
          v-model="lieu"
          :options="lieux"
          optionValue="id"
          optionLabel="nom"
          placeholder="Lieux d'examen"
          :disabled="desac"
        />
        <p class="subTitle">3. Souhaitez-vous modifier votre préférence pour le moniteur</p>
        <select name="mono" id="mono" v-model="mono">
          <option value="">Choisir un moniteur</option>
          <template v-for="m in monos" :key="m.id">
            <option :value="m.id">{{ m.nom }}</option>
          </template>
        </select>
        <p class="subTitle">4. Souhaitez-vous apporter une modification à vos impératifs ?</p>
        <textarea name="com" id="com" v-model="commentaire"></textarea>
        <div class="btnChoixDemande">
          <button class="btn btn-danger" @click="cancelDemande" v-if="loadBtn === false">ANNULER MA DEMANDE</button>
          <button @click="cancelDemande" class="btn btn-danger" disabled v-else><span><i class="fa fa-spinner fa-spin"></i>ANNULER MA DEMANDE</span></button>
          <button class="btn btn-primary" @click="setDemande(this.passage[0].id, 'edit')" v-if="loadBtn === false">VALIDER MES MODIFS</button>
          <button @click="setDemande(this.passage[0].id, 'edit')" class="btn btn-primary" disabled v-else><span><i class="fa fa-spinner fa-spin"></i>VALIDER MES MODIFS</span></button>
        </div>
      </div>
    </template>

    <template v-else-if="this.exam.length !== 0 && this.exam[0].score === null && this.exam[0].dateProb === null && this.examBlanc.length !== 0 || this.exam.length === 0 && this.examBlanc.length !== 0 || this.exam.length !== 0 && this.exam[0].score === null && this.exam[0].dateProb === null && this.examBlanc.length === 0">
      <div class="demandePassage">
        <div class="examBlanc">
          <p class="subTitle">1.Votre examen blanc est programmé :</p>
          <p v-if="this.examBlanc.length === 0">En attente de programmation</p>
          <p v-else>Le {{ this.examBlanc[0].date }} de {{ this.examBlanc[0].heureDeb }}h à {{ this.examBlanc[0].heureFin }}h ({{ this.examBlanc[0].lieu }}) RDV au {{ this.$store.state.user.agence.nom }}</p>
        </div>
        <div class="exam">
          <p class="subTitle">2.Votre examen de conduite est programmé :</p>
          <p v-if="this.exam.length === 0">En attente de programmation</p>
          <template v-else>
            <p>Le {{ this.exam[0].date }} à {{ this.exam[0].heureDeb }}h ({{ this.exam[0].lieu }}) RDV au {{ this.$store.state.user.agence.nom }}</p>
            <p class="subTitle">3. Votre résultat d'examen sera publié sur cette page au plus tard le {{ this.exam[0].resultDate }}</p>
          </template>

        </div>
        <div class="heures">
          <p class="subTitle" v-if="this.infoEleve.heureAProg > this.$store.state.elevePlanningInfo.heureTot">4. Il vous reste {{this.infoEleve.heureAProg}}h de conduite à programmer avant l'examen. Nous vous conseillons de les placer sur le planning dès maintenant</p>
          <p class="subTitle" v-else>4. Il vous reste {{this.$store.state.elevePlanningInfo.heureTot}}h de conduite à programmer avant l'examen. Nous vous conseillons de les placer sur le planning dès maintenant</p>
          <button class="btn btn-primary" @click="goToHome()">J'ai compris !</button>
        </div>
      </div>
    </template>

    <template v-else-if="this.exam[0].score >= 20 && this.exam[0].eli === null">
      <div class="demandePassage">
        <div class="examResult">
          <p class="subTitle">1. Résultat de l'examen de condutie :</p>
          <p>{{ this.exam[0].date }} à {{ this.exam[0].heureDeb }} ({{ this.exam[0].lieu }})</p>
          <p>EXAMEN REUSSI</p>
          <p>FELICITATIONS !! Et merci de nous avoir fait confiance pour votre formation !</p>
        </div>
        <div class="permis">
          <p class="subTitle">2. Confiez-nous l'établissement de votre permis de conduire pour {{this.infoEleve.etablissementPermis}} €</p>
          <button class="btn btn-success">Etablissement du Permis de Conduire {{this.infoEleve.etablissementPermis}}€</button>
        </div>
      </div>
    </template>

    <template v-else-if="this.exam[0].score < 20 && this.exam[0].score !== null || this.exam[0].eli === true || this.exam[0].dateProb !== null">
      <div class="demandePassage">
        <div class="examResult">
          <template v-if="this.exam[0].score < 20 && this.exam[0].score !== null || this.exam[0].eli === true">
            <p class="subTitle">1. Résultat de l'examen de conduite :</p>
            <p>{{ this.exam[0].date }} à {{ this.exam[0].heureDeb }} ({{ this.exam[0].lieu }})</p>
            <p>EXAMEN ÉCHOUÉ</p>
            <p class="subTitle">Vous pourrez refaire une nouvelle demande à partir du {{ this.exam[0].dateProbTxt }}</p>
          </template>
          <template v-else>
            <p class="subTitle">1. Résultat de l'examen de conduite :</p>
            <p>{{ this.exam[0].date }} à {{ this.exam[0].heureDeb }} ({{ this.exam[0].lieu }})</p>
            <p>EXAMEN ANNULÉ</p>
            <p class="subTitle">Vous pourrez refaire une nouvelle demande à partir du {{ this.exam[0].dateProbTxt }}</p>
          </template>
        </div>
        <div class="goNxt" v-if="this.exam[0].score < 20 && this.exam[0].score !== null || this.exam[0].eli === true">
          <p class="subTitle">2. Vous devez programmer un cours de 2H. Nous pourrons ainsi refaire le point sur votre niveau</p>
          <p class="subTitle">3. Suite à ce cours, un nombre d'heures vous sera préconisé afin que le prochain examen soit le bon</p>
        </div>
        <button class="btn btn-primary" @click="goToPlanning">PLANNING</button>
      </div>
    </template>

  </div>
</template>

<script>

import Loader from "@/components/Loader.vue";
// import HeureaProg from "@/components/agence/planning/split/HeureaProg.vue";

export default {

  props: [

  ],

  components: {
    Loader,
    // HeureaProg
  },

  data() {
    return {
      passage : [],
      examBlanc : [],
      exam : [],
      examEc : [],
      lieux : [],
      lieuxSelect : [],
      monos : "",
      idMono : "",
      lieu : "",
      commentaire : "",
      infoEleve : [],
      loadPage : 0,
      loadBtn : false,
    };
  },

  mounted() {
    this.getPassageInfo();
  },

  methods: {

    getEleveInfo() {
      window.api
        .get("/exam/eleve/prix/" + this.$store.state.user.id, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          this.infoEleve = response.data;
          this.loadPage++;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goToPlanning(){
      this.$router.push({ name: "eleve_conduite" });
    },

    goToHome(){
      this.$router.push({ name: "Home" });
    },

    setDemande(type, mode){
        this.loadBtn = true;
        if(this.mono === ""){
            alert("Veuillez choisir un moniteur");
            this.loadBtn = false;
        }else if(this.lieu === ""){
            alert("Veuillez choisir un lieu");
            this.loadBtn = false;
        }else{

          if(mode === "edit"){
            if (window.confirm("Êtes-vous sûr de demander une date d'examen pour cet élève ?")){
              window.api
                .post(
                  "/set/demande/exam/" + type + "/" + mode,
                  {
                    id: this.$store.state.user.id,
                    ids: this.$store.state.user.id,
                    idMono: this.mono,
                    lieu: this.lieu,
                    commentaire: this.commentaire,
                  },
                  {
                    headers: {
                      Authorization: "Bearer " + this.$store.state.token,
                    },
                  }
                )
                .then(() => {
                  this.getPassageInfo();
                })
                .catch((error) => {
                  console.log(error);
                });
            }
          }else{
            window.api
              .get(
                "/can/demande/"+this.$store.state.user.id,
                {
                  headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                  },
                }
              )
              .then((response) => {
                this.loadBtn = false;
                if(response.data.demande === false){
                  alert("Votre solde n'est pas suffisant pour pouvoir demander une date d'examen, vous devez avoir au minimum "+response.data.limite+"€ en solde");
                }else{
                    if (window.confirm("Êtes-vous sûr de demander une date d'examen pour cet élève ?")){
                      window.api
                        .post(
                          "/set/demande/exam/" + type + "/" + mode,
                          {
                            id: this.$store.state.user.id,
                            ids: this.$store.state.user.id,
                            idMono: this.mono,
                            lieu: this.lieu,
                            commentaire: this.commentaire,
                          },
                          {
                            headers: {
                              Authorization: "Bearer " + this.$store.state.token,
                            },
                          }
                        )
                        .then(() => {
                          this.getPassageInfo();
                        })
                        .catch((error) => {
                          console.log(error);
                        });
                    }
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }


        }
    },

    cancelDemande(){
      this.loadBtn = true;
      if(this.exam.length !== 0){
        alert("Vous ne pouvez pas annuler votre demande car vous avez un examen de programmé.");
        this.loadBtn = false;
      }else if(this.examBlanc.length !== 0){
        alert("Vous ne pouvez pas annuler votre demande car vous avez un examen blanc de programmé.");
        this.loadBtn = false;
      }else{
        if(window.confirm("Êtes-vous sûr de vouloir annuler votre demande d'examen ?")){
          window.api
            .get(
              "/cancel/demande/passage/" + this.passage[0].id,
              {
                headers: {
                  Authorization: "Bearer " + this.$store.state.token,
                },
              }
            )
            .then(() => {
              this.lieu = [];
              this.mono = "";
              this.commentaire = "";
              this.getPassageInfo();
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }

    },

    getLieuBoite(){
      window.api
        .get(
          "/boite/lieu/exam/",
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          }
        )
        .then((response) => {
          this.lieux = response.data.lieux;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getMonosEleve(){
      window.api
        .get(
          "/eleve/choixmono/" + this.$store.state.user.id,
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          }
        )
        .then((response) => {
          this.loadPage++;
          if(response.data.monos.length === 0){
            alert("Veuillez choisir un / des moniteurs dans la partie paramétrage de votre planning, avant de demander une place d'examen");
            this.loadPage = 3;
            this.$router.push({ name: 'eleve_conduite' });
          }
          this.monos = response.data.monos;
          
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getPassageInfo(){
    window.api
      .get("/passage/exam/examblanc/eleve/" + this.$store.state.user.id, {
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      })
      .then((response) => {
        this.passage = response.data.passageInfo;
        this.examBlanc = response.data.examBlanc;
        this.exam = response.data.exam;
        this.examEc = response.data.examEc;

        if(this.passage.length !== 0){
          this.lieu = this.passage[0].lieux;
          this.commentaire = this.passage[0].commentaire;
          this.mono = this.passage[0].monoId;
        }
        this.loadPage++;
        this.getLieuBoite();
        this.getMonosEleve();
        this.getEleveInfo();
        this.loadBtn = false;
      })
      .catch((error) => {
        console.log(error);
      });
    }

  },



};
</script>

<style scoped>
/* ============================================================
   BASE & BACKGROUND
   ============================================================ */
div.background {
  min-height: 100vh;
  width: 100%;
  background: #f4f6f9;
}

/* ============================================================
   HEADER
   ============================================================ */
div.header {
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  padding: 0 32px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 300;
  box-shadow: 0 1px 3px rgba(0,0,0,.06), 0 1px 2px rgba(0,0,0,.04);
}

div.header h1 {
  font-size: 20px;
  font-weight: bold;
  color: #1a1f2e;
  letter-spacing: -0.3px;
  margin: 0;
}

div.header .btn-danger {
  background: #fee2e2;
  color: #ef4444;
  border: 1px solid #fca5a5;
  padding: 7px 14px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}

div.header .btn-danger:hover {
  background: #ef4444;
  color: #ffffff;
}

/* ============================================================
   MAIN CARD
   ============================================================ */
div.demandePassage {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  width: 80%;
  max-width: 860px;
  margin: 32px auto;
  padding: 8px 0 24px;
  box-shadow: 0 4px 16px rgba(0,0,0,.08), 0 2px 6px rgba(0,0,0,.04);
  overflow: hidden;
}

/* ============================================================
   TYPOGRAPHY
   ============================================================ */
div.demandePassage p.title {
  font-size: 22px;
  font-weight: 400;
  color: #1a1f2e;
  letter-spacing: -0.3px;
  padding: 20px 28px 4px;
  margin: 0;
}

div.demandePassage p.subTitle {
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 20px 28px 0;
  margin: 0;
  text-align: left;
}

div.demandePassage p:not(.title):not(.subTitle) {
  font-size: 14px;
  color: #1a1f2e;
  padding: 6px 28px 0;
  margin: 0;
}

/* ============================================================
   SECTIONS (examBlanc, exam, heures, examResult, permis, goNxt)
   ============================================================ */
div.examBlanc,
div.exam,
div.heures,
div.examResult,
div.permis,
div.goNxt {
  border-top: 1px solid #e2e8f0;
  padding: 4px 0;
  margin-top: 16px;
}

div.examBlanc:first-child,
div.exam:first-child,
div.heures:first-child,
div.examResult:first-child {
  border-top: none;
  margin-top: 0;
}

/* ============================================================
   FORM CONTROLS
   ============================================================ */
div.demandePassage textarea {
  display: block;
  width: calc(100% - 56px);
  height: 120px;
  margin: 10px 28px 0;
  padding: 10px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f4f6f9;
  font-size: 13px;
  color: #1a1f2e;
  resize: vertical;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}

div.demandePassage textarea:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59,130,246,.08);
  background: #ffffff;
}

div.demandePassage select {
  display: block;
  margin: 10px 28px 0;
  padding: 9px 32px 9px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f4f6f9 url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E") no-repeat right 10px center;
  -webkit-appearance: none;
  font-size: 13px;
  color: #1a1f2e;
  cursor: pointer;
  outline: none;
  transition: border-color 0.15s;
  width: auto;
  min-width: 220px;
}

div.demandePassage select:focus {
  border-color: #3b82f6;
}

div.demandePassage .mutltiSelectLieux {
  display: block;
  width: calc(100% - 56px);
  margin: 10px 28px 0;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f4f6f9;
  font-size: 13px;
}

/* ============================================================
   BUTTONS
   ============================================================ */
div.demandePassage .btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 18px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all 0.15s;
  white-space: nowrap;
  margin: 20px 0 4px 28px;
}

div.demandePassage .btn-primary {
  background: #3b82f6;
  color: #ffffff;
}

div.demandePassage .btn-primary:hover {
  background: #2563eb;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(59,130,246,.3);
}

div.demandePassage .btn-primary:disabled {
  opacity: 0.65;
  cursor: not-allowed;
  transform: none;
}

div.demandePassage .btn-danger {
  background: #fee2e2;
  color: #ef4444;
  border: 1px solid #fca5a5;
}

div.demandePassage .btn-danger:hover {
  background: #ef4444;
  color: #ffffff;
}

div.demandePassage .btn-danger:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

div.demandePassage .btn-success {
  background: #1a9e6e;
  color: #ffffff;
}

div.demandePassage .btn-success:hover {
  background: #168a5f;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(26,158,110,.3);
}

div.btnChoixDemande {
  display: flex;
  gap: 10px;
  padding: 0 0 0 0;
  flex-wrap: wrap;
}

div.btnChoixDemande .btn {
  margin-left: 28px;
}
</style>